const allMyProjects = [   
    {        
      images: [
      "./Images/Projects/useoimg/USEO-2.jpeg",
      "./Images/Projects/useoimg/USEO-3.jpeg",
        "./Images/Projects/useoimg/USEO-1.jpeg", 
        "./Images/Projects/useoimg/U.S.E.O.jpeg", 
        
        
      ],
      title: "U.S.E.O Project",
      description: "USEO is a powerful app that helps you optimize your website's search engine performance with ease.",
      githubLink: "https://github.com/",
     
    },
    {
      images: [
        "./Images/Projects/carimg/CAR3.jpeg", 
        "./Images/Projects/carimg/CAR2.jpeg",  
        "./Images/Projects/carimg/CAR.jpeg", 
      ],
      title: "Cars information Application",
      description: "Car Inf is an intuitive app that provides detailed information and statistics about your car's performance and maintenance needs.",
      githubLink: "https://github.com/",
   
    },
    {
      images: [
        "./Images/Projects/plantationimg/PLANT3.jpeg",
      "./Images/Projects/plantationimg/PLANT1.jpeg", 
        "./Images/Projects/plantationimg/PLANT2.jpeg", 
        
      ],
      title: "Planting Application design",
      description: "Planting Info is an all-in-one app that provides useful information and tips on how to grow and care for various types of plants.",
      githubLink: "https://github.com/",
    
    },
    {
      images: [
        "./Images/Projects/coachimg/COACH.jpeg", 
        "./Images/Projects/coachimg/COACH1.jpeg", 
      ],
      title: "Coach Applicstion design",
      description: "Coach is a helpful app that provides personalized coaching and guidance to help you achieve your personal or professional goals.",
      githubLink: "https://github.com/anisriaz/",
     
    },
    {
      images: [
        "./Images/Projects/productsimg/PRODUCTS1.jpeg", 
        "./Images/Projects/productsimg/PRODUCTS2.jpeg",
        "./Images/Projects/productsimg/PRODUCTS3.jpeg",
      ],
      title: "Ecommerce App design",
      description: "Ecommerce is a user-friendly app that allows you to easily buy and sell products online, anytime and anywhere.",
      githubLink: "https://github.com/",
      
    }
  ];
  
  export default allMyProjects;
